import {
  AdvantageCardsWrapper,
  AnnunciationLink,
  CentralImage,
  CentralImageWrapper,
  ContentWrapper,
  DescriptionParagraph,
  DescriptionTitle,
  DesktopCardsWrapper,
  DesktopUpHideWrapper,
  ImagesWrapper,
  Logo,
  Wrapper,
} from "./styles";

import logo from "../../../../assets/pages/NewHome/logo.png";
import { ADVANTAGES } from "./components/AdvantageCard/constants";
import AdvantageCard from "./components/AdvantageCard";
import React from "react";
import staffImg from "../../../../assets/pages/NewHome/ClientsSection/staff7cantos.jpeg";
import ClientCard from "./components/ClientCard";
import CustomButton from "../../../../components/CustomButton";
import { Link } from "react-router-dom";

function AnunciatePropertySection() {
  return (
    <Wrapper>
      <ImagesWrapper>
        <Logo src={logo} />
        <CentralImageWrapper>
          <CentralImage src={staffImg} alt="Time 7Cantos" loading="lazy" />
        </CentralImageWrapper>
        <DesktopUpHideWrapper>
          {ADVANTAGES.map((advantage) => (
            <AdvantageCard key={advantage.title} {...advantage} />
          ))}
        </DesktopUpHideWrapper>
      </ImagesWrapper>
      <ContentWrapper>
        <DescriptionTitle>
          Alcance mais clientes e anuncie seu imóvel com a gente
        </DescriptionTitle>
        <DescriptionParagraph>
          Maximize a visibilidade do seu imóvel e alcance um público mais amplo
          ao anunciar com 7cantos. Com nossa plataforma de fácil utilização e
          alcance significativo, garantimos que seu imóvel receba a atenção que
          merece.
        </DescriptionParagraph>
        <DesktopCardsWrapper>
          <AdvantageCardsWrapper>
            {ADVANTAGES.map((advantage) => (
              <AdvantageCard key={advantage.title} {...advantage} />
            ))}
          </AdvantageCardsWrapper>
          <ClientCard />
        </DesktopCardsWrapper>
        <Link to="/advertise-property" target="_blank">
          <CustomButton>Anunciar Imóvel</CustomButton>
        </Link>
      </ContentWrapper>
    </Wrapper>
  );
}

export default AnunciatePropertySection;
